
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import { Validations } from 'vuelidate-property-decorators';
  import { required, minValue, maxLength } from 'vuelidate/lib/validators';
  import { EventBus } from '@/event-bus';

  import { EnumModel, AreaType, AreaTypeEnums } from '@/common/enumerations';
  import { Client, ITravelTimeModel, TravelTimeModel, TravelTimeUpdateModel } from '@/services/api.service';
  import { TravelTimeUpdatedMessage } from '@/services/eventbus.models';
  import * as StringUtils from '@/utilities/string.utils';

  @Component({
    props: {
      travelTime: {
        type: Object as () => ITravelTimeModel,
        required: false
      },
      isInDialogMode: Boolean
    }
  })
  export default class TravelTimeEdit extends Vue {
    private gid: string = '';
    private locality: string = '';
    private postcode: string = '';
    private areaType: EnumModel | null = null;
    private travelTimeInHours: number = 0;
    private travelTimeInMinutes: number = 0;

    private availableAreaTypes: EnumModel[] = [];

    public formIsValid: boolean | null = null;

    @Validations()
    private validations = {
      locality: { required },
      postcode: { required }
    };

    private mounted() {
      this.availableAreaTypes.push(...AreaTypeEnums);
      this.areaType = this.availableAreaTypes[0];

      console.log('TravelTimeEdit:mounted:', this.$props.travelTime);
      if (this.$props.travelTime) {
        this.gid = this.$props.travelTime.gid;
        this.locality = this.$props.travelTime.locality;
        this.postcode = this.$props.travelTime.postcode;
        const locatedAreaType = this.availableAreaTypes.find(at => at.value === this.$props.travelTime.areaType);
        if (locatedAreaType) {
          this.areaType = locatedAreaType;
        }
        this.travelTimeInHours = Math.floor(this.$props.travelTime.timeInMinutes  / 60);
        this.travelTimeInMinutes = this.$props.travelTime.timeInMinutes  % 60;
      }
    }

    private updateTravelTime() {
      // Do the work here
      // Run the validation
      // @ts-ignore
      this.$v.$touch();
      const me = this;
      // @ts-ignore
      if (me.$v.$invalid) {
        this.formIsValid = false;
        console.log('Submit failed. Form is invalid.');
      } else {
        // do your submit logic here
        me.formIsValid = true;
        console.log('Submit started. Form valid.');
        const updateTravelTime: TravelTimeUpdateModel = new TravelTimeUpdateModel();
        const travelTime: number = +(this.travelTimeInHours * 60) + +this.travelTimeInMinutes;

        updateTravelTime.init({
          gid: this.gid,
          locality: this.locality,
          postcode: this.postcode,
          areaType: this.areaType && this.areaType.value || AreaType.Urban,
          timeInMinutes: travelTime
        });
        console.log(updateTravelTime);
        const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
        // @ts-ignore
        me.$Progress.start();
        clientService.updateTravelTime(this.gid, updateTravelTime).then((data: TravelTimeModel) => {
          // Route to the edit job list screen?
          console.log('Returned travel time:');
          console.log(data);
          // @ts-ignore
          me.$Progress.finish();
          // @ts-ignore
          me.$awn.success('Travel time for ' + me.locality + ' updated successfully');
          me.$emit('traveltime-updated', data);
          EventBus.$emit('traveltime-updated', new TravelTimeUpdatedMessage(data));
          me.closeModal();
        });
      }
    }
    private cancelEdit() {
      console.log('Cancelling edit...');
      // this.$emit('close');
      this.closeModal();
    }

    private closeModal() {
      this.$modal.hide('modal-traveltime-edit');
    }
  }
